import { render, staticRenderFns } from "./pictureLibrary.vue?vue&type=template&id=fc2dc2fa&scoped=true"
import script from "./pictureLibrary.vue?vue&type=script&lang=js"
export * from "./pictureLibrary.vue?vue&type=script&lang=js"
import style0 from "./pictureLibrary.vue?vue&type=style&index=0&id=fc2dc2fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2dc2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc2dc2fa')) {
      api.createRecord('fc2dc2fa', component.options)
    } else {
      api.reload('fc2dc2fa', component.options)
    }
    module.hot.accept("./pictureLibrary.vue?vue&type=template&id=fc2dc2fa&scoped=true", function () {
      api.rerender('fc2dc2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/pictureLibrary.vue"
export default component.exports